module.exports = __webpack_public_path__ + "static/scale-model-of-wichita-kansas-97940f16ea2e469fef0ba2e1f482c020.png";